import { API_URL } from '@/utils/static';
import { ERRORS } from '@/utils/static/errors';
import { api } from '@/api';

export const newObject = (obj, key, value) => {
  let copy = Object.assign({}, obj);
  copy[key] = value;
  return copy;
};

export const getFileSrc = (url, isReferral) => {
  return isReferral ? `${API_URL}/agent/${url}` : `${API_URL}/${url}`;
};

export const getFilenameFromUrl = (url) => {
  const nameParts = url.split('-');
  const filteredParts = nameParts.filter((item, index) => index > nameParts.length - 2);
  return filteredParts.join('-');
};

export const getUrlName = (url, index) => {
  try {
    const array = url.split('/');
    const array2 = array[array.length - 1].split('-');
    return array2[array2.length - 1];
  } catch (e) {
    return `File ${index}`;
  }
};

const addZero = (val) => {
  return `0${val}`.slice(-2);
};

export const dateString = (date, shortYear, withTime) => {
  let hours = date.getHours();
  let minutes = date.getMinutes();

  if (date)
    return `${addZero(date.getDate())}.${addZero(date.getMonth() + 1)}.${
      shortYear ? date.getFullYear() % 100 : date.getFullYear()
    } ${withTime ? `${addZero(hours)}:${addZero(minutes)}` : ''}`;

  return '';
};

export const dateFromDatePicker = (date) => {
  if (date) {
    const formattedDate = new Date(date.replace(/^"(.*)"$/, '$1'));
    return `${addZero(formattedDate.getDate())}.${addZero(
      formattedDate.getMonth() + 1
    )}.${formattedDate.getFullYear()}`;
  }

  return '';
};

export const displayFullDate = (date, withoutTime = false, lang = 'en') => {
  let day = ('0' + date.getDate()).slice(-2);
  let month = ('0' + (date.getMonth() + 1)).slice(-2);
  let year = date.getFullYear();
  let hours = date.getHours();
  let minutes = date.getMinutes();

  return `${day}.${month}.${year}${withoutTime ? '' : ` ${addZero(hours)}:${addZero(minutes)}`}`;
};

export const objectToFormData = (obj) => {
  let formData = new FormData();
  Object.keys(obj).forEach((key) => {
    formData.append(key, obj[key]);
  });

  return formData;
};

export const getErrorMessage = (err) => {
  const defaultError = 'Something went wrong';
  try {
    return ERRORS[err.response.data.message] || err.response.data.message || defaultError;
  } catch {
    return defaultError;
  }
};

export const downloadFileByLink = async (name, url, referralToken) => {
  const res = await api.get(url, {
    responseType: 'blob',
    ...(referralToken && {
      headers: {
        Authorization: `Bearer ${referralToken}`
      }
    })
  });

  if (res && res.data) {
    downloadFile(name, URL.createObjectURL(res.data));
  }
};
export const downloadFile = (name, url) => {
  let tempLink = document.createElement('a');

  tempLink.setAttribute('href', url);
  tempLink.setAttribute('download', name);

  document.documentElement.appendChild(tempLink);
  tempLink.click();

  document.documentElement.removeChild(tempLink);
};
export const downloadImgFromBlob = (data, fileTitle, blobType, isBuffer = false) => {
  const blob = new Blob([isBuffer ? new Uint8Array(data) : data], {
    ...(blobType && { type: blobType })
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileTitle);
  link.click();
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
};

export const sortWithNulls = (a, b) => {
  // equal items sort equally
  if (a === b) {
    return 0;
  }

  // nulls sort after anything else
  if (a === null || a === 0) {
    return 1;
  }
  if (b === null || b === 0) {
    return -1;
  }

  return a < b ? -1 : 1;
};

export const parseType = (type) => {
  const logTexts = ['status product updated', 'status updated'];

  const verificationDivider = '|';

  let title = type;
  let restText = '';
  logTexts.forEach((text) => {
    if (type.includes(text)) {
      title = type.replace(text, '').trim();
      title = title.replace('+', '').trim();
      title = title.replace(',', '').trim();

      if (title.includes(verificationDivider)) {
        const index = title.indexOf(verificationDivider);
        const text1 = title.slice(0, index).trim();
        const text2 = title.slice(index + 1, title.length).trim();
        title = text1;
        restText = verificationDivider + ' ' + text2 + ' ' + text.trim();
      } else {
        restText = text.trim();
      }
    }
  });
  return { title: title, restText: restText };
};

export function sumFloat(array) {
  if (!Array.isArray(array)) {
    throw new Error('Input must be an array.');
  }

  return array.reduce((sum, num) => sum + (num ? Number(num) : 0), 0);
}

export const getDeadTime = (minutes, seconds) => {
  let deadline = new Date();
  if (minutes) deadline.setMinutes(deadline.getMinutes() + minutes);
  if (seconds) deadline.setSeconds(deadline.getSeconds() + seconds);
  return deadline;
};
export const getTimeRemaining = (e) => {
  const total = Date.parse(e.toString()) - Date.parse(new Date().toString());
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  return {
    total,
    minutes,
    seconds
  };
};
export function areArraysEqual(arr1, arr2) {
  if (!arr1 || !arr2) return false;
  if (arr1.length !== arr2.length) return false;

  let a1 = arr1.slice().sort();
  let a2 = arr2.slice().sort();

  return a1.every((value, index) => value === a2[index]);
}
export const getLocalizedText = (object, propName, i18n) => {
  if (!object || !propName || !i18n) return '';

  const currentLang = i18n.language.split('-')[0].toUpperCase();
  const langKey = `${propName}_${currentLang}`;

  if (object[langKey]) {
    return object[langKey];
  }

  return object[propName];
};
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getLocalizedValue(lang, fieldName, data, isDate) {
  const upperLang = lang.toUpperCase();
  const localizedField = `${fieldName}_${upperLang}`;

  if (data && data.hasOwnProperty(localizedField) && data[localizedField]) {
    return isDate ? dateString(new Date(data[localizedField])) : data[localizedField];
  }

  if (data && data.hasOwnProperty(fieldName)) {
    return isDate ? dateString(new Date(data[fieldName])) : data[fieldName];
  }

  return '';
}
export function getExtensionFromUrl(urlPath) {
  try {
    const filename = urlPath.split('/').pop();

    const dotIndex = filename.lastIndexOf('.');

    return dotIndex !== -1 ? filename.substring(dotIndex + 1) : null;
  } catch (error) {
    console.error('Invalid URL provided', error);
    return null;
  }
}
